import { Animation, createAnimation } from '@ionic/core';

export const alertModalAndroidEnterAnimation = (baseEl: HTMLElement): Animation => {
  if (!baseEl) {
    return createAnimation();
  }

  const backdropAnimation = createAnimation();
  const wrapperAnimation = createAnimation();
  const modalContentAnimation = createAnimation();

  const backdropEl = baseEl.querySelector('ion-backdrop');
  if (backdropEl) {
    backdropAnimation
      .addElement(backdropEl)
      .fromTo('opacity', 0.01, 'var(--backdrop-opacity)')
      .beforeStyles({ 'pointer-events': 'none' })
      .afterClearStyles(['pointer-events']);
  }

  const wrapperEl = baseEl.querySelectorAll('.modal-wrapper, .modal-show');
  if (wrapperEl) {
    wrapperAnimation.addElement(wrapperEl).beforeStyles({
      opacity: 1,
      transform: 'translateY(0vh)',
    });
  }

  const contentEl = baseEl.querySelector('.modal-content');
  if (contentEl) {
    modalContentAnimation.addElement(contentEl).keyframes([
      { offset: 0, opacity: 0.01, transform: 'translateY(40px)' },
      { offset: 1, opacity: 1, transform: 'translateY(0px)' },
    ]);
  }

  const baseAnimation = createAnimation()
    .addElement(baseEl)
    .easing('cubic-bezier(0.36,0.66,0.04,1)')
    .duration(280)
    .addAnimation([backdropAnimation, wrapperAnimation, modalContentAnimation]);

  return baseAnimation;
};
